/* ==========================================================================
   Saunt — product card image slider.

   snippets/card-product.liquid renders two image sets per card:

     <picture class="desktop_view">        one featured image
     <div class="product-image-slider">    one .product-image-slide per variant

   Below 990px the slider is the visible one, and it is a Slick carousel.
   This file initialises it.

   Previously this logic sat inline in layout/theme.liquid behind
   `template.suffix == 'sections-sunglassesb' or template.name == 'index'`,
   so collection and search pages never initialised Slick and every slide
   rendered stacked vertically. Now it runs everywhere and no-ops when there
   is nothing to initialise.

   Behaviour beyond the original:
     - idempotent: never double-initialises a slider
     - re-runs after AJAX grid replacement (facets, pagination, infinite scroll)
     - debounced resize handling, with teardown above 990px
     - skips single-slide sliders entirely
     - only swallows a swatch click when a matching slide actually exists,
       so the theme's existing swatch behaviour is left untouched

   Slide/swatch pairing is by data-variant-name, which card-product.liquid
   puts on .product-image-slide and on .color-swatch.mobile_view. The legacy
   .variant_label swatches carry no such attribute, so this script leaves
   them entirely alone.
   ========================================================================== */

(function () {
  'use strict';

  var BREAKPOINT = 990;
  var SLIDER = '.product-image-slider';
  var SLIDE = '.product-image-slide';
  var SWATCH = '.color-swatch.mobile_view';

  var SLICK_OPTIONS = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    touchMove: true
  };

  // jQuery and Slick are loaded from theme.liquid's <head>, but this script is
  // deferred and the CDN copies can be slow, so poll briefly rather than assume.
  function whenReady(callback, attempt) {
    attempt = attempt || 0;
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      callback(window.jQuery);
      return;
    }
    if (attempt > 80) return; // ~8s, then give up quietly
    setTimeout(function () {
      whenReady(callback, attempt + 1);
    }, 100);
  }

  whenReady(function ($) {
    var resizeTimer = null;
    var refreshTimer = null;
    var refreshing = false;

    function key(el) {
      if (!el || !el.getAttribute) return '';
      var value = el.getAttribute('data-variant-name');
      return value ? value.trim().toLowerCase() : '';
    }

    // Mark the swatch matching the visible slide. No-op when nothing matches,
    // so a partial set of swatches never clears the active state entirely.
    function syncSwatches($card, wanted) {
      if (!wanted || !$card.length) return;

      var $swatches = $card.find(SWATCH);
      var $match = $swatches.filter(function () {
        return key(this) === wanted;
      });

      if (!$match.length) return;

      $swatches.removeClass('is-active');
      $match.addClass('is-active');
    }

    function initSlider(el) {
      var $slider = $(el);

      if ($slider.hasClass('slick-initialized')) return;
      if ($slider.find(SLIDE).length < 2) return;

      $slider
        .slick(SLICK_OPTIONS)
        .on('afterChange', function (event, slick, currentSlide) {
          var $slide = $(slick.$slides[currentSlide]);
          syncSwatches($slide.closest('.card-wrapper'), key($slide[0]));
        });

      syncSwatches($slider.closest('.card-wrapper'), key($slider.find(SLIDE)[0]));
    }

    function destroySlider(el) {
      var $slider = $(el);
      if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
    }

    function refresh() {
      if (refreshing) return;
      refreshing = true;

      try {
        var small = window.innerWidth < BREAKPOINT;
        $(SLIDER).each(function () {
          if (small) {
            initSlider(this);
          } else {
            destroySlider(this);
          }
        });
      } catch (error) {
        if (window.console) console.error('[saunt-card-slider]', error);
      } finally {
        refreshing = false;
      }
    }

    function scheduleRefresh(delay) {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refresh, delay || 150);
    }

    $(document).on('click', SWATCH, function (event) {
      var $card = $(this).closest('.card-wrapper');
      var $slider = $card.find(SLIDER);

      // Above the breakpoint, or before Slick has attached, leave the swatch
      // alone — the theme's own <color-swatch> element and the variant link
      // both still need to work.
      if (!$slider.length || !$slider.hasClass('slick-initialized')) return;

      var wanted = key(this);
      if (!wanted) return;

      var target = -1;
      $slider.find('.slick-slide:not(.slick-cloned)').each(function () {
        if (key(this) === wanted) {
          target = parseInt(this.getAttribute('data-slick-index'), 10);
          return false;
        }
      });

      if (target < 0 || isNaN(target)) return;

      event.preventDefault();
      $slider.slick('slickGoTo', target);

      $card.find(SWATCH).removeClass('is-active');
      $(this).addClass('is-active');
    });

    $(window).on('resize orientationchange', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 200);
    });

    // Facets, pagination and infinite scroll swap the grid out from under us.
    // refresh() is idempotent, so the observer settles after one pass.
    function observeGrid() {
      if (!window.MutationObserver) return;

      var target = document.getElementById('MainContent') || document.body;
      if (!target) return;

      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            scheduleRefresh(150);
            return;
          }
        }
      }).observe(target, { childList: true, subtree: true });
    }

    // Theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', function () {
      scheduleRefresh(0);
    });

    $(function () {
      refresh();
      observeGrid();
    });
  });
})();
